import React, { Component } from 'react';
import { Form , FormGroup, Label, FormControl, PageHeader, Image} from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { CSVLink } from "react-csv";
import './style.css';


class AddCoupon extends Component {
  
  constructor(props){
    super(props)
    this.state={
      file:'',
      responseMessage: '',
      show: false,
      value: ''
    };
   
   
    this._handleImageChange = this._handleImageChange.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this.couponList = this.couponList.bind(this);
  }

  componentWillReceiveProps(nextprops){
    if(nextprops.success && nextprops.couponSaveResponse){
      this.setState({
        responseMessage: nextprops.couponSaveResponse.message,
        show: true,
        value : ''
      });
    }else if(nextprops.couponSaveResponse){
      this.setState({
        responseMessage: nextprops.couponSaveResponse.error,
        show: true,
        value : ''
      });
    }
  }
 

  validateForm() {
    return  this.state.file;
  }

 

  _handleImageChange(e) {
    let reader = new FileReader();
    let file1 = e.target.files[0];

    this.setState({
      file: file1,
      value: e.target.value,
    });
}

_handleSubmit(e) {
  e.preventDefault();
 const data = new FormData();
 data.append('file', this.state.file);
 this.setState({
   file: '',
 });

 this.props.AddCoupon(data);
}

couponList(){
  this.props.couponListViewPage();
}

  render(){

  const headers = [
    { label: "Coupon_code", key: "Coupon_code" },
    { label: "Coupon_type", key: "Coupon_type" },
    { label: "Description", key: "Description" },
    { label: "Expire_date", key: "Expire_date" },
    { label: "Coupon_amount", key: "Coupon_amount" }
  ];
   
  const data = [
    { Coupon_code: "101", Coupon_type: "one time use", Description: "coupon for my test", Expire_date: "2018-10-25T07:21:31.753Z", Coupon_amount: "200"   },
    { Coupon_code: "102", Coupon_type: "one time use", Description: "coupon for my test", Expire_date: "2018-10-25", Coupon_amount: "200"   },
  ];
    return (
      <div className = "regPage">
        <div className = "form">
        <div className = "GNNheading"><h1>Add Coupon</h1></div>
        
        <br/><button className = "backbutton"   onClick={this.couponList}>Back</button>
          <div className = "registerform">
          <Form className="formCat" >
            <PageHeader><small>Add Coupon</small></PageHeader>
             Click to get formate of csv file.&nbsp;&nbsp;&nbsp;
             
                <CSVLink data={data} headers={headers}>
                  Download me
                </CSVLink>


            <input type="file" accept=".csv" onChange={this._handleImageChange} value={this.state.value}/><br/>
            <button type="submit" disabled={!this.validateForm()} onClick={this._handleSubmit} className="btn btn-primary btn-md" >Submit</button><br/>
          </Form>
          </div>
          
          <SweetAlert
             show={this.state.show}
            title={<span> <h5>{this.state.responseMessage}</h5></span>}
             text="hello"
             confirmBtnBsStyle="default"
             onConfirm={() => this.setState({ show: false })}
           />
        </div><br/>
        </div>
      
    );
  }
}
export default AddCoupon;



// WEBPACK FOOTER //
// ./src/components/coupon/index.js